<template>
  <div class="scrollable" v-loading.fullscreen.lock="fullscreenLoading">
  	<v-header></v-header>
    <div class="content">
    	<div class="breadNav">
        <P>个人中心 > 体检订单</P>
      </div>
      <div class="nav">
        <div class="navChild">
          <div class="left">
            <p :class="{active1:index==isActive}" :key="index" v-for="(item,index) in $t('m.phyOrderList.orderNavList')" @click="changeNav(index)" >{{item}} <span v-if="index == 1 && count>0" class="number">{{count}}</span></p>
          </div>
        </div>
      </div>
      <div class="titList" v-if="orderDataList.length>0">
        <p class="detail">{{$t('m.phyOrderList.titList.orderDetail')}}</p>
        <p class="name">{{$t('m.phyOrderList.titList.username')}}</p>
        <p class="price">{{$t('m.phyOrderList.titList.price')}}</p>
        <p class="status">{{$t('m.phyOrderList.titList.status')}}</p>
        <p class="handle">{{$t('m.phyOrderList.titList.handle')}}</p>
      </div>
      <div class="orderList" v-if="orderDataList.length>0">
        <div class="orderItem" :key="index" v-for="(item,index) in orderDataList">
          <div :class="item.status == 0?'top bg1':(item.status == 1000?'top bg3':'top bg2')">
            <p style="font-weight: bold;"><span>{{$t('m.phyOrderList.orderItem.orderTime')}}： </span>{{item.create_time}}</p>
            <p style="font-weight: bold;"><span>{{$t('m.phyOrderList.orderItem.orderNum')}}：</span>{{item.order_no}}</p>
          </div>
          <div class="msg">
            <div class="detail" style="font-size: 14px;">
              <p style="margin-top: 18px;">{{item.combo}} {{item.combo_desc}}</p>
              <p>{{$t('m.phyOrderList.orderItem.hospital')}}：{{item.hospital == null?$t('m.common.noHave'):item.hospital.name}}</p>
              <p>{{$t('m.phyOrderList.orderItem.appointment')}}：{{item.exam_date == null?$t('m.common.noHave'):item.exam_date}}</p>
              <p v-if="item.report_authorize == 0 && item.person.relationship == 0&&item.hospital.report_type == 0&&item.hospital.branch_type == 0" style="margin-top:15px">报告状态：未授权-前台咨询获取纸质报告<em v-if="item.status == 1000 || item.status == 1 || item.status == 2">或</em> <span v-if="item.status == 1000 || item.status == 1 || item.status == 2" @click="againBtn(item)" style="color:#FF000F;cursor:pointer;text-decoration: underline;">重新授权</span></p>
              <p v-if="item.report_authorize == 1 && item.person.relationship == 0&&item.hospital.report_type == 0&&item.hospital.branch_type == 0" style="margin-top:15px">报告状态：已授权-检后7-10个工作日在线查看电子报告</p>
              <p v-if="item.person.relationship == 0 && (item.hospital.report_type!=0 || (item.hospital.report_type==0 && item.hospital.branch_type==1))" style="margin-top:15px">报告状态：该分院不支持在本平台查看体检报告，报告获取方式请在体检结束后向前台咨询</p>
              <p v-if="item.person.relationship != 0 " style="margin-top:15px">报告状态：本平台暂无法提供家属体检报告查询功能</p>
            </div>
            <div class="name" v-if="item.person" style="width: 200px;">
              <p>{{item.person.name}}【{{item.person.relationship_value}}】</p>
            </div>
            <div class="price">
              <p>{{$t('m.phyOrderList.orderItem.payMoney')}}：¥{{item.paid_money}}</p>
              <!-- <p></p>
              <p v-if="item.status == 1000" style="color: #FF000F;">{{$t('m.phyOrderList.orderItem.payCountdown')}}：{{item.hh}} : {{item.mm}} : {{item.ss}}</p>
              <p v-else style="color: #FF000F;">{{item.pay_type_text}}</p> -->
            </div>
            <div class="status">
              <p :class="item.status == 0?'status1':(item.status == 2?'status2':(item.status == 3?'status3':(item.status == 4 || item.status == 1007 || item.status == 1003?'status4':(item.status == 1 || item.status == 1000  || item.status == 7?'status5':(item.status == 5?'status6':'status7') || item.status == 6?'status8':'status7' ))))">{{item.status_text}}</p>
            </div>
            <div class="handle" v-if="item.status == 0">
                <p @click="getDetails(item.order_no)">{{$t('m.phyOrderList.orderItem.getDetail')}}</p>
              <p @click="cancelOrder(item.order_no)" v-if="item.can_cancel">{{$t('m.phyOrderList.orderItem.cancelOrder')}}</p>
              <p @click="immediateAppointment(item.order_no)">{{$t('m.phyOrderList.orderItem.immediateAppointment')}}</p>
            </div>
            <div class="handle" v-if="item.status == 41">
                <p @click="getDetails(item.order_no)">{{$t('m.phyOrderList.orderItem.getDetail')}}</p>
            </div>
            <div class="handle" v-if="item.status == 2">
                <p @click="getDetails(item.order_no)">{{$t('m.phyOrderList.orderItem.getDetail')}}</p>
              <p v-if="item.person.relationship === 0" @click="jumpURL(item.hospital.name,item.hospital.area.name,item.order_no)" style="padding: 5px 0;">{{$t('m.phyOrderList.orderItem.degree')}}</p>
              <!-- <p @click="goSales(item.order_no)">申请售后</p> -->
            </div>
            <div class="handle" v-if="item.status == 4">
                <p @click="getDetails(item.order_no)">{{$t('m.phyOrderList.orderItem.getDetail')}}</p>
            </div>
            <div class="handle" v-if="item.status == 6">
                <p @click="getDetails(item.order_no)">{{$t('m.phyOrderList.orderItem.getDetail')}}</p>
            </div>
            <div class="handle" v-if="item.status == 31">
                <p @click="getDetails(item.order_no)">{{$t('m.phyOrderList.orderItem.getDetail')}}</p>
            </div>
            <!-- <div class="handle2" v-if="item.status == 3">
              <p>{{$t('m.phyOrderList.orderItem.reAppointment')}}</p>
            </div> -->
            <div class="handle" v-if="item.status == 1 || item.status == 3">
                <p @click="getDetails(item.order_no)">{{$t('m.phyOrderList.orderItem.getDetail')}}</p>
              <p @click="changeTime(item.combo_id,item.hospital.id,item.order_no,item.person.relationship,item.project.id)"  v-if="item.can_change">{{$t('m.phyOrderList.orderItem.appointmentRescheduling')}}</p>
              <p @click="cancelOrder(item.order_no)" v-if="item.can_cancel">{{$t('m.phyOrderList.orderItem.cancelOrder')}}</p>
            </div>
            <div class="handle" v-if="item.status == 1000">
                <p @click="getDetails(item.order_no)">{{$t('m.phyOrderList.orderItem.getDetail')}}</p>
              <p @click="cancelOrder(item.order_no)" v-if="item.can_cancel">{{$t('m.phyOrderList.orderItem.cancelOrder')}}</p>
              <p @click="payBtn(item.order_no)">{{$t('m.phyOrderList.orderItem.immediatePayment')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="nayOrder" v-else>
        <img src="../../../assets/order.png">
        <p>{{$t('m.phyOrderList.noOrder')}}</p>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        class="page-box"
        v-if="total > 10"
        layout="prev, pager, next"
        :total="total"
        :current-page="page_num"
        :page-size="page_size"
        @current-change="pageChange">
      </el-pagination>
    </div>
    <v-footer></v-footer>
     <!-- 授权报告 -->
     <el-dialog :visible.sync="reportVisible" :close-on-click-modal="false" style="border-radius: 20px;">
        <div class="reportMsg" >
          <p style="font-size:33px;margin-bottom: 10px;font-weight: bold;text-align: center;color: #333333;">体检报告授权协议</p>
          <p style="color: #333;font-size: 18px;">亲爱的用户，您好！</p>
          <p  style="color: #333;font-size: 18px;">请查看并阅读<a style="color: #e51e26;cursor: pointer;text-decoration: underline;" target="1" href="../../../../static/pdf/用户授权协议.pdf">《体检报告授权协议》</a>，确定是否同意在本平台查看体检报告。</p>
          <p style="font-size:16px;color:#333;">注：</p>
          <p style="font-size: 16px;color: #333;line-height: 25px;">1.连锁私立体检机构（爱康/美年/瑞慈）默认为电子报告，您授权后即可在本平台查看并使用报告解读等服务；</p>
          <p style="font-size: 16px;color: #333;margin: 5px 0;line-height: 25px;">2.和谐健康等其他民营机构的报告的报告，需由各机构指定的方式获取。您获取后，在电脑端上传个人体检报告，方能使用报告解读以及健康评估等服务。</p>
          <p style="font-size: 16px;color: #333;line-height: 25px;">3.公立医院为纸质报告，需自取或团检统一返还，并由您在电脑端上传个人体检报告以后，方能使用报告解读以及健康评估等服务。</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button  @click="reportVisible=false">取消</el-button>
          <el-button type="primary" @click="agreeBtn">{{
                      $t("m.common.define")
                      }}</el-button>
        </span>
      </el-dialog>
    <!-- 预约改期弹窗 -->
    <el-dialog
      :title="$t('m.phyOrderList.orderItem.appointmentRescheduling')"
      :visible.sync="changeTimeVisible" :close-on-click-modal="false">
      <div id='changeTime'>
          <el-date-picker
            v-model="timeVal"
            type="date" @change="getTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            :placeholder="$t('m.phyOrderList.orderItem.chooseTime')" class="chooseTime" :picker-options="pickerOptions">
          </el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeTimeVisible = false">{{$t('m.common.cancelBtn')}}</el-button>
        <el-button type="primary" :loading="btnLoading" @click="changeTimeOk">{{$t('m.common.define')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
    import axios from 'axios';
    import {
        mapActions,
        mapGetters
    } from 'vuex';
    import header from '../../common/header.vue'
    import footer from '../../common/footer.vue'

    var timeData = [];
    export default {
        name: 'orderList',
        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        // timeData = [];
                        var year = time.getFullYear(),
                            month = ("0" + (time.getMonth() + 1)).slice(-2),
                            date = ("0" + time.getDate()).slice(-2);
                        var dateStr = year + "-" + month + "-" + date;
                        return timeData.indexOf(dateStr) == -1;

                    },
                },
                timer: null,
                isFirstEnter: false, // 定义变量来判断是否第一次进入，默认false
                activeName: '1',
                isActive: 0,
                orderDataList: [],
                allOrder: [],
                data1: [],
                data2: [],
                data3: [],
                data4: [], //data1是待体检   data2是已到检   data3是已过期    data4是已关闭
                rocallTime: '',
                changeTimeVisible: false,
                comboId: '',
                hospitalId: '',
                timeVal: '',
                order_no: '',
                total: 0,
                page_num: 1,
                page_size: 10,
                status_type: 0,
                // project:{},
                relationship: 0,
                projectId: 0,
                newOrderDataList: [],
                fullscreenLoading: false,
                btnLoading: false,
                reportVisible: false,
                institutionType: '',
                phyPersonType: '',
                count: 0

            }
        },
        components: {
            "v-header": header,
            "v-footer": footer
        },
        created() {
            let _this = this;
            _this.isFirstEnter = true;
            _this.institutionType = sessionStorage.getItem('institutionType')
            _this.phyPersonType = sessionStorage.getItem('type')
            _this.authorization = sessionStorage.getItem('authorization')
                // _this.project = JSON.parse(sessionStorage.getItem('project'));
        },
        beforeRouteEnter(to, from, next) {
            if (from.name == "PhyOrderDetails") {
                // 这个name是下一级页面的路由name
                to.meta.isBack = true; // 设置为true说明你是返回到这个页面，而不是通过跳转从其他页面进入到这个页面
            }
            next();
        },
        activated() {
            let _this = this;
            if (!_this.$route.meta.isBack || _this.isFirstEnter) {
                _this.activeName = '1';
                _this.isActive = 0;
                _this.orderDataList = [];
                _this.newOrderDataList = [];
                _this.allOrder = [];
                _this.data1 = [];
                _this.data2 = [];
                _this.data3 = [];
                _this.data4 = [];
                _this.rocallTime = '';
                _this.changeTimeVisible = false;
                _this.comboId = '';
                _this.hospitalId = '';
                _this.timeVal = '';
                _this.order_no = '';
                _this.total = 0;
                _this.page_num = 1;
                _this.page_size = 10;
                _this.status_type = 0;
                _this.relationship = 0;
                _this.projectId = 0;
                _this.isActive = _this.$route.query.check;
                _this.status_type = _this.$route.query.statusType;
                _this.fullscreenLoading = false;
                // _this.getOrderList();
                // _this.getTimeList();
                // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
                // 如果isFirstEnter是true，表明是第一次进入此页面或用户刷新了页面，需获取新数据
            }
            // // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
            _this.$route.meta.isBack = false;
            // // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
            _this.isFirstEnter = false;
            //  _this.status_type = _this.$route.query.statusType;
            _this.getOrderList();
            // console.log('90909099090')

        },
        methods: {
            ...mapActions( // 语法糖
                ['message'] // 相当于this.$store.dispatch('modifyName'),提交这个方法
            ),
            //立即支付
            payBtn(order_no) {
                window.location.href = pay_URL + '/cashier/pc/?order_no=' + order_no;
            },
            //申请售后
            goSales(order_no) {
                this.$router.push({
                    path: '/afterMarket/index',
                    query: {
                        order_no: order_no,
                    }
                })
            },
            againBtn(item) {
                this.reportVisible = true;
                this.againMsg = item;
            },
            //重新授权
            disAgreeBtn() {
                let _this = this;
                _this.fullscreenLoading = true;
                axios
                    .post(`${BASE_URL}/exam/reports/second/authorize/`, {
                        project: _this.againMsg.project.id,
                        order_no: _this.againMsg.order_no,
                        authorize: 0,
                    })
                    .then((res) => {
                        _this.reportVisible = false;
                        _this.fullscreenLoading = false;
                        _this.getOrderList();
                    })
                    .catch((err) => {
                        _this.fullscreenLoading = false;
                    });
            },
            agreeBtn() {
                let _this = this;
                _this.fullscreenLoading = true;
                axios
                    .post(`${BASE_URL}/exam/reports/second/authorize/`, {
                        project: _this.againMsg.project.id,
                        order_no: _this.againMsg.order_no,
                        authorize: 1,
                    })
                    .then((res) => {
                        _this.reportVisible = false;
                        _this.fullscreenLoading = false;
                        _this.getOrderList();
                    })
                    .catch((err) => {
                        _this.fullscreenLoading = false;
                    });
            },
            pageChange(val) {
                let _this = this;
                _this.fullscreenLoading = true;
                _this.page_num = val;
                _this.newOrderDataList = [];
                //获取订单列表接口
                axios.get(BASE_URL + '/exam/orders/?status_type=' + _this.status_type + '&page=' + val).then((res) => {
                    _this.fullscreenLoading = false;
                    _this.orderDataList = res.data.data.results;
                    res.data.data.results.map(((item, index) => {
                        if (item.status === 1000) {
                            _this.newOrderDataList.push(item)
                        }
                    }))
                    if (_this.newOrderDataList.length != 0) {
                        _this.newOrderDataList.map(((item, index) => {
                            _this.$set(item, "ss", _this.getTimeList())
                        }))
                    }
                }).catch((err) => {
                    _this.fullscreenLoading = false;
                })
            },
            //满意度调查
            jumpURL(name1, name2, subOrderNo) {
                // 获取问卷填写状态
                axios.get(BASE_URL + '/exam/survey/abb/is_completed/').then((res) => {
                    if (!res.data.data.status) {
                        this.$router.push({
                            path: '/investigate',
                            query: {
                                hospital: name2 + ' ' + name1,
                                subOrderNo: subOrderNo,
                            }
                        })
                    } else {
                        this.$message.error('您已提交过满意度调查，请勿重复提交')
                    }
                }).catch((err) => {

                })
            },
            //更换体检日期
            changeTimeOk() {
                let _this = this;
                if (_this.timeVal) {
                    _this.btnLoading = true;
                    axios.put(BASE_URL + '/exam/orders/' + _this.order_no + '/', {
                        exam_date: _this.timeVal
                    }).then((res) => {
                        // console.log(res);
                        _this.btnLoading = false;
                        _this.changeTimeVisible = false;
                        _this.getOrderList();
                        let data = {
                            message: _this.$t('m.phyOrderList.orderItem.appointmentSuccess'),
                            type: 'success',
                            center: true
                        }
                        _this.message(data);
                    }).catch((err) => {
                        _this.btnLoading = false;
                    })
                } else {
                    _this.$message.error('请选择日期')
                }

            },
            //获取可约时间列表
            getHosTime(order_no) {
                let _this = this;
                timeData = [];
                axios.get(BASE_URL + '/exam/orders/' + order_no + '/schedule/').then((res) => {
                    console.log(res);
                    let data = res.data.data;
                    data.forEach(function(element) {
                        if (element.maxNum > element.usedNum) {
                            timeData.push(element.regDate);
                        }
                    })
                    _this.pickerOptions = {
                        disabledDate(time) {
                            // timeData = [];
                            var year = time.getFullYear(),
                                month = ("0" + (time.getMonth() + 1)).slice(-2),
                                date = ("0" + time.getDate()).slice(-2);
                            var dateStr = year + "-" + month + "-" + date;
                            return timeData.indexOf(dateStr) == -1;

                        },
                    }
                })
            },
            //选择时间
            getTime(val) {
                // console.log(val)
                let _this = this;
                _this.timeVal = val;
            },
            //预约改期
            changeTime(comboId, hospitalId, order_no, relationship, projectId) {
                let _this = this;
                _this.timeVal = '';
                _this.changeTimeVisible = true;
                _this.comboId = comboId;
                _this.hospitalId = hospitalId;
                _this.order_no = order_no;
                _this.relationship = relationship;
                _this.projectId = projectId;
                _this.getHosTime(order_no);
            },
            //立即预约
            // immediateAppointment(order_no){
            //   let _this = this;
            //   _this.$router.push({
            //     path:'/depSubscribe',
            //     query:{
            //       order_no:order_no
            //     }
            //   })
            // },
            getTimeList() {
                var _this = this;
                setInterval(function() {
                    for (var key in _this.newOrderDataList) {
                        let a = _this.newOrderDataList[key].create_time;
                        const b = a.replace(/-/g, '/');
                        let ti = new Date(b).getTime();
                        var start = new Date().getTime();
                        var end = new Date(ti + 1 * 60 * 60 * 1000).getTime();
                        var rightTime = end - start;
                        // console.log(ti)
                        if (rightTime > 0) {
                            var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
                            var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
                            var mm = Math.floor((rightTime / 1000 / 60) % 60);
                            var ss = Math.floor((rightTime / 1000) % 60);
                            //  console.log(dd)
                            dd = dd > 9 ? dd : '0' + dd
                            hh = hh > 9 ? hh : '0' + hh
                            mm = mm > 9 ? mm : '0' + mm
                            ss = ss > 9 ? ss : '0' + ss
                            _this.newOrderDataList[key]["dd"] = dd;
                            _this.newOrderDataList[key]["hh"] = hh;
                            _this.newOrderDataList[key]["mm"] = mm;
                            _this.newOrderDataList[key]["ss"] = ss;
                        } else {
                            _this.newOrderDataList[key]["dd"] = 0;
                            _this.newOrderDataList[key]["hh"] = 0;
                            _this.newOrderDataList[key]["mm"] = 0;
                            _this.newOrderDataList[key]["ss"] = 0;
                            //  _this.getOrderList();
                        }
                    }
                }, 1000);
                // _this.getOrderList();
            },
            //取消订单
            cancelOrder(order_no) {
                console.log(order_no)
                let _this = this;
                _this.$confirm(_this.$t('m.phyOrderList.cancelOrderModal.isCancel'), {
                    confirmButtonText: _this.$t('m.common.define'),
                    cancelButtonText: _this.$t('m.common.cancelBtn')
                        // type: 'warning'
                }).then(() => {
                    axios.delete(BASE_URL + '/exam/orders/' + order_no + '/').then((res) => {
                        console.log(res);
                        _this.getOrderList();
                        let data = {
                            message: _this.$t('m.phyOrderList.cancelOrderModal.cancelSuss'),
                            type: 'success',
                            center: true
                        }
                        _this.message(data);
                    })

                }).catch(() => {

                });
            },
            //获取订单列表
            getOrderList() {
                let _this = this;
                _this.fullscreenLoading = true;
                _this.newOrderDataList = [];
                //获取订单列表接口
                axios.get(BASE_URL + '/exam/orders/?status_type=' + _this.status_type).then((res) => {
                    _this.fullscreenLoading = false;
                    _this.total = res.data.data.count;
                    _this.orderDataList = res.data.data.results;
                    if (_this.status_type == 5) {
                        _this.count = res.data.data.count
                    }
                    res.data.data.results.map(((item, index) => {
                        if (item.status === 1000) {
                            _this.newOrderDataList.push(item)
                        }
                    }))
                    if (_this.newOrderDataList.length != 0) {
                        _this.newOrderDataList.map(((item, index) => {
                            _this.$set(item, "ss", _this.getTimeList())
                        }))
                    }
                }).catch((err) => {
                    _this.fullscreenLoading = false;
                })
            },
            //查看多久的订单
            // handleCommand(command) {
            //   this.$message('click on item ' + command);
            // },
            //切换nav
            changeNav(index) {
                let _this = this;
                _this.isActive = index;
                if (index == 0) {
                    _this.status_type = 0;
                    _this.getOrderList();
                } else if (index == 1) {
                    _this.status_type = 5;
                    _this.getOrderList();
                } else if (index == 2) {
                    _this.status_type = 1;
                    _this.getOrderList();
                } else if (index == 3) {
                    _this.status_type = 2;
                    _this.getOrderList();
                } else if (index == 4) {
                    _this.status_type = 3;
                    _this.getOrderList();
                }
            },
            //查看订单详情
            getDetails(order_no) {
                let _this = this;
                _this.$router.push({
                    path: '/phyOrderDetails',
                    query: {
                        order_no: order_no
                    }
                })
            },
        },
        watch: {
            //     orderDataList: {
            // 　　　　handler(newValue, oldValue) {
            //   // console.log(oldValue)
            // 　　　　　　for (let i = 0; i < newValue.length; i++) {
            //               if (newValue[i].mm === 22) {
            //               clearInterval(this.timer)
            //               this.timer = null;
            //                   // this.getOrderList();
            // 　　　　　　　　}
            // // 　　　　　　　　if (newValue[i].dd === 0 && newValue[i].hh === 0 && newValue[i].mm === 0 && newValue[i].ss === 0) {
            // //                   this.getOrderList();
            // // 　　　　　　　　}
            // 　　　　　　}
            // 　　　　},
            // 　　　　deep: true
            // 　　}
        },
        computed: {

            // ...mapGetters(['resturantName','resturantId']) // 动态计算属性，相当于this.$store.getters.resturantName
        },
        mounted() {
            let _this = this;
            // _this.getTimeList();
        },
    }
</script>

<style scoped>
    .page-box {
        display: flex;
        justify-content: center;
        margin-bottom: 50px;
    }
    
    .chooseTime {
        width: 100% !important;
        /*margin-bottom: 280px;*/
    }
    
    .nayOrder {
        width: 1180px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        padding: 100px 0;
    }
    
    .nayOrder img {
        width: 380px;
        height: 210px;
    }
    
    .nayOrder p {
        font-size: 16px;
        font-weight: 400;
        color: #999;
        line-height: 16px;
        margin-top: 30px;
    }
    
    .status1 {
        color: #E51E26;
    }
    
    .status2 {
        color: #1FBA80;
    }
    
    .status3 {
        color: #D0021B;
    }
    
    .status4 {
        color: #333333;
    }
    
    .status5 {
        color: #FF000F;
    }
    
    .status6 {
        color: #D0021B;
    }
    
    .status7 {
        color: #e94709;
    }
    
    .status8 {
        color: #D0021B;
    }
    
    .bg1 {
        background: rgba(229, 30, 38, 0.0969);
    }
    
    .bg2 {
        background: #f2f2f2;
    }
    
    .bg3 {
        background: #FFE6E7;
    }
    
    .orderItem .msg .handle2 p {
        font-size: 14px;
        font-weight: 600;
        color: #FF000F;
        line-height: 14px;
        text-align: center;
        text-decoration: underline;
        cursor: pointer;
        width: 180px;
    }
    
    .orderItem .msg .handle p {
        font-size: 14px;
        font-weight: 600;
        color: #FF000F;
        line-height: 14px;
        text-align: center;
        text-decoration: underline;
        cursor: pointer;
    }
    
    .orderItem .msg .handle p:nth-child(2) {
        margin: 10px 0;
    }
    
    .orderItem .msg .status {
        font-size: 18px;
        text-align: center;
        font-weight: 600;
        line-height: 18px;
    }
    
    .orderItem .msg .price p:nth-child(1) {
        font-size: 14px;
        font-weight: 400;
        color: #333;
        line-height: 14px;
    }
    
    .orderItem .msg .price p:nth-child(2) {
        width: 165px;
        height: 2px;
        background: #EAEAEA;
        margin: 0 auto;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    
    .orderItem .msg .price p:nth-child(3) {
        font-size: 14px;
        font-weight: 400;
        color: #333;
        line-height: 14px;
    }
    
    .orderItem .msg .name p {
        font-size: 14px;
        font-weight: 400;
        color: #333;
        line-height: 14px;
    }
    
    .orderItem .msg .detail {
        width: 460px;
        padding: 15px 0;
    }
    
    .orderItem .msg .detail p:nth-child(1) {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        line-height: 14px;
    }
    
    .orderItem .msg .detail p:nth-child(2) {
        margin-top: 15px;
        font-size: 14px;
        font-weight: 400;
        color: #333;
        line-height: 14px;
    }
    
    .orderItem .msg .detail p:nth-child(3) {
        margin-top: 15px;
        font-size: 14px;
        font-weight: 400;
        color: #333;
        line-height: 14px;
    }
    
    .orderItem .msg .detail p:nth-child(3) span {
        color: #e94709;
        text-decoration: underline;
        padding-left: 20px;
        cursor: pointer;
    }
    
    .orderItem .msg .name {
        width: 200px;
        display: flex;
        justify-content: center;
    }
    
    .orderItem .msg .price {
        width: 200px;
        text-align: center;
    }
    
    .orderItem .msg .status {
        width: 140px;
        display: flex;
        justify-content: center;
    }
    
    .orderItem .msg .handle {
        width: 180px;
    }
    
    .orderItem .msg {
        width: 100%;
        height: 117px;
        display: flex;
        align-items: center;
        padding-left: 20px;
    }
    
    .orderItem .top p {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        line-height: 14px;
        margin-right: 40px;
    }
    
    .orderItem .top p span {
        font-size: 14px;
        font-weight: 500;
        color: #666;
        line-height: 14px;
    }
    
    .orderItem .top {
        width: 100%;
        height: 46px;
        display: flex;
        align-items: center;
        padding-left: 20px;
    }
    
    .orderItem {
        width: 1180px;
        height: 180px;
        border: 1px solid #ccc;
        margin: 0 auto;
        margin-bottom: 30px;
    }
    
    .orderItem:last-child {
        margin-bottom: 51px;
    }
    
    .titList {
        width: 1180px;
        margin: 0 auto;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .titList p {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        line-height: 14px;
    }
    
    .titList .detail {
        width: 480px;
        display: flex;
        justify-content: center;
    }
    
    .titList .name {
        width: 180px;
        display: flex;
        justify-content: center;
    }
    
    .titList .price {
        width: 200px;
        display: flex;
        justify-content: center;
    }
    
    .titList .status {
        width: 140px;
        display: flex;
        justify-content: center;
    }
    
    .titList .handle {
        width: 180px;
        display: flex;
        justify-content: center;
    }
    
    .nav {
        width: 100%;
        border-bottom: 2px solid #EAEAEA;
    }
    
    .navChild {
        width: 1180px;
        height: 50px;
        display: flex;
        margin: 0 auto;
        align-items: center;
        justify-content: space-between;
    }
    
    .navChild .left {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    
    .navChild .left p {
        font-weight: 600;
        cursor: pointer;
        position: relative;
        color: #333;
        font-size: 16px;
        margin-right: 36px;
    }
    
    .active {
        color: #e94709 !important;
        font-size: 18px !important;
    }
    
    .breadNav {
        width: 100%;
        height: 80px;
        border-bottom: 2px solid #EAEAEA;
        display: flex;
        align-items: center;
    }
    
    .breadNav p {
        width: 1180px;
        margin: 0 auto;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 20px;
    }
    
    .active1 {
        color: #FF000F !important;
        font-size: 18px !important
    }
    
    .number {
        width: 18px;
        height: 18px;
        position: absolute;
        right: -13px;
        top: -8px;
        font-size: 12px;
        border-radius: 50%;
        text-align: center;
        line-height: 18px;
        display: inline-block;
        color: #fff;
        background: #FF000F;
    }
</style>


// WEBPACK FOOTER //
// src/components/phyExServices/orderList/list.vue